import { render, staticRenderFns } from "./newExchangeCode.vue?vue&type=template&id=12b9ce70&scoped=true&"
import script from "./newExchangeCode.vue?vue&type=script&lang=js&"
export * from "./newExchangeCode.vue?vue&type=script&lang=js&"
import style0 from "./newExchangeCode.vue?vue&type=style&index=0&id=12b9ce70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b9ce70",
  null
  
)

export default component.exports